module.exports = __webpack_public_path__ + "media/images/landing/dno/product-3-1bcad29743611a3c52a81d560c6e38a6.png";